import React from 'react'
import OperacionesTareasMovimiento from '../containers/OperacionesTareasMovimiento'
import moment from 'moment'

export const COLUMNS_MOVIMIENTOS_DE_MERCADERIA = [
  {
    name: 'fechaDeInicio',
    label: 'Fecha Inicio',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
    }
  },
  {
    name: 'fechaDeFinalizacion',
    label: 'Fecha Finalización',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM HH:mm')}</> : null
    }
  },
  {
    name: 'tarea',
    label: 'Tarea',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'toneladas',
    label: 'Tns.',
    options: {
      filter: true,
      sort: true
    }
  }
]
export const COLUMNS_MOVIMIENTOS_DE_MERCADERIA_TO_PRINT = [
  {
    name: 'fechaDeInicio',
    label: 'Fecha Inicio',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'fechaDeFinalizacion',
    label: 'Fecha Finalización',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'tarea',
    label: 'Tarea',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'toneladas',
    label: 'Tns.',
    width: 50,
    mantenerCase: true
  }
]

export const COLUMNS_TAREAS_MOVIMIENTO_MERCADERIA_PENDIENTES = [
  {
    name: 'fechaDeInicio',
    label: 'Fecha Inicio',
    with: 80,
    options: {
      filter: false,
      sort: false,
      filterType: 'multiselect',
      customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD-MM-YY HH:mm')}</> : null
    }
  },
  {
    name: 'tarea',
    label: 'Tarea',
    with: 50,
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'fechaRegistroTarea',
    label: 'Operaciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: value => {
        return <OperacionesTareasMovimiento fechaRegistroTarea={value} />
      }
    }
  }
]
